module.exports = "../../../../platform/assets/pageMainIcon/youth_jichudanganlei1.svg";